export const DEFAULT_LOGO = "/img/mrva-logo-white.png";

export const Logo = ({ size = 34, className = "", src }) => (
  <img src={src || DEFAULT_LOGO} alt="MRVA Productions" style={{ height: size }} className={`w-auto max-w-[200px] object-contain select-none ${className}`} draggable="false" />
);

export const Wordmark = ({ src }) => <Logo size={36} src={src} />;
